import generic_backend_request_post from 'functions/server/generic_backend_request_post';

async function delete_saved_scenario(scenario_id) {
    if (!scenario_id) {
        throw new Error('Scenario ID is required')
    }
    if (typeof scenario_id !== 'string') {
        throw new Error('Scenario ID must be a string')
    }
    const requestJson = {
        "scenario_id": scenario_id
    }
    const retJson = await generic_backend_request_post(requestJson, '/delete_saved_scenario')
    return retJson;    

}

export default delete_saved_scenario